// Setup puritanLawn namespace
var puritanLawn = puritanLawn || {
    // *** ENUMS ***
    fileType: {
        SandboxImage: 0,
        SandboxVideo: 1,
        QRCode: 2,
        ContactUsImage: 3,
        UserProfileImage: 4,
        StaffProfileImage: 5,
        DynamicContentImage: 6,
        DynamicContentVideo: 7,
        DeceasedProfileImage: 8,
        DeceasedObituaryImage: 9,
        DeceasedGalleryImage: 10,
        DeceasedMemorialImage: 11,
        DeceasedTributeImage: 12,
        ProductImage: 13,
        DeceasedUpload: 14,
        DeceasedExport: 15,
        UserExport: 16,
        UserOrderExport: 17,
        ResourceUpload: 18,
        MainBanner: 19,
        GuestExport: 20,
        FuneralHomeExport: 21,
        ParkSectionImage: 22,
        HeroImage: 23,
        ProductExport: 24
    },
    // *** PROPERTIES ***
    model: null,
    viewModel: null,
    adminServicesBaseAddress: null,
    // jQuery.validate ignore selectors: Jodit editor + reCAPTCHA.
    validatorIgnoreQuillAndRecaptcha: ':hidden:not(#wysiwyg), .jodit-container, .jodit-container *, .g-recaptcha, .g-recaptcha *, textarea[name^="g-recaptcha-response"], input[type="file"]:not([name])',
    validatorIgnoreRecaptcha: ':hidden, .g-recaptcha, .g-recaptcha *, textarea[name^="g-recaptcha-response"], input[type="file"]:not([name])',
    // *** METHODS ***
    submitterForDisplay: function (submittedBy, submittedByDefaultValue, dateSubmitted) {
        //var value = "Submitted by: " + (submittedBy ?? submittedByDefaultValue);

        var value = "Submitted by: ";

        if (submittedBy == null) {
            value = value + submittedByDefaultValue;
        }
        else {
            value = value + submittedBy;
        }

        if (dateSubmitted) {
            var d = new Date(dateSubmitted);
            if (!isNaN(d.getTime())) {
                var y = d.getFullYear();
                var mo = d.getMonth() + 1;
                var day = d.getDate();
                var dateStr = y + '-' + (mo < 10 ? '0' : '') + mo + '-' + (day < 10 ? '0' : '') + day;
                value = value + ' on ' + dateStr;
            }
        }

        return value;
    },
    ajaxGet: function (url,
        onSuccess,
        onError,
        onBeforeSend) {
        $.ajax(
            {
                url: url,
                type: "GET",
                dataType: "json",
                cache: false,
                processData: false,
                contentType: false, // No content-type header sent
                beforeSend: onBeforeSend,
                success: onSuccess,
                error: onError
            });
    },
    ajaxPostMultiPartFormData: function (url,
        data,
        onSuccess,
        onError,
        onBeforeSend)
    {
        $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "json",
                cache: false,
                data: data,
                processData: false,
                contentType: false, // No content-type header sent
                beforeSend: onBeforeSend,
                success: onSuccess,
                error: onError
            });
    },
    cancel: function () {
        history.go(-1);
    },
    plSubmitConfirmationModalCancelButtonClickHandler: function (e) {
        //alert('Cancel');
        if (e.data.callback) e.data.callback();

        puritanLawn.plTwoButtonModalDetachButtonClickHandlers(puritanLawn.plSubmitConfirmationModalSubmitButtonClickHandler, puritanLawn.plSubmitConfirmationModalSubmitButtonClickHandler)
    },
    plSubmitConfirmationModalSubmitButtonClickHandler: function (e) {
        //alert('Submit');
        if (e.data.callback) e.data.callback();

        puritanLawn.plTwoButtonModalDetachButtonClickHandlers(puritanLawn.plSubmitConfirmationModalSubmitButtonClickHandler, puritanLawn.plSubmitConfirmationModalSubmitButtonClickHandler)

        var form = $("#pl-form");

        if (form) form.submit();
    },

    // TODO: Add icon support to modals (Info, Question, Warn, Error)

    // One button modal
    plOneButtonModalOnButtonClick: function (e) {
        //alert('Yes');
        puritanLawn.plOneButtonModalDetachButtonClickHandlers(puritanLawn.plOneButtonModalOnButtonClick)
        if (e.data.callback) e.data.callback();
    },
    plOneButtonModalAttachButtonClickHandlers: function (onButtonClick, onButtonClickData) {
        $("#pl-oneButtonModalButton").on("click", { callback: onButtonClickData }, onButtonClick);
    },
    plOneButtonModalDetachButtonClickHandlers: function (onButtonClick) {
        $("#pl-oneButtonModalButton").off("click", onButtonClick);
    },

    showOneButtonModal: function (title, content, button, onButton) {
        $("#pl-oneButtonModalTitle").html(title);
        $("#pl-oneButtonModalContent").html(content);
        $("#pl-oneButtonModalButton").text(button);
        puritanLawn.plOneButtonModalAttachButtonClickHandlers(puritanLawn.plOneButtonModalOnButtonClick, onButton);
        $('#pl-oneButtonModal').modal();
    },

    // Two button modal
    plTwoButtonModalOnButton1Click: function (e) {
        //alert('Yes');
        puritanLawn.plTwoButtonModalDetachButtonClickHandlers(puritanLawn.plTwoButtonModalOnButton1Click, puritanLawn.plTwoButtonModalOnButton2Click)
        if (e.data.callback) e.data.callback();
    },
    plTwoButtonModalOnButton2Click: function (e) {
        //alert('No');
        puritanLawn.plTwoButtonModalDetachButtonClickHandlers(puritanLawn.plTwoButtonModalOnButton1Click, puritanLawn.plTwoButtonModalOnButton2Click)
        if (e.data.callback) e.data.callback();
    },
    plTwoButtonModalAttachButtonClickHandlers: function (onButton1Click, onButton1ClickData, onButton2Click, onButton2ClickData) {
        $("#pl-twoButtonModalButton1").on("click", { callback: onButton1ClickData }, onButton1Click);
        $("#pl-twoButtonModalButton2").on("click", { callback: onButton2ClickData }, onButton2Click);
    },
    plTwoButtonModalDetachButtonClickHandlers: function (onButton1Click, onButton2Click) {
        $("#pl-twoButtonModalButton1").off("click", onButton1Click);
        $("#pl-twoButtonModalButton2").off("click", onButton2Click);
    },
    showTwoButtonModal: function (title, content, button1, onButton1, button2, onButton2) {
        $("#pl-twoButtonModalTitle").html(title);
        $("#pl-twoButtonModalContent").html(content);
        $("#pl-twoButtonModalButton1").text(button1);
        $("#pl-twoButtonModalButton2").text(button2);
        puritanLawn.plTwoButtonModalAttachButtonClickHandlers(puritanLawn.plTwoButtonModalOnButton1Click,
            onButton1,
            puritanLawn.plTwoButtonModalOnButton2Click,
            onButton2);
        $('#pl-twoButtonModal').modal();
    },

    // Three button modal
    plThreeButtonModalOnButton1Click: function (e) {
        puritanLawn.plThreeButtonModalDetachButtonClickHandlers(puritanLawn.plThreeButtonModalOnButton1Click, puritanLawn.plThreeButtonModalOnButton2Click, puritanLawn.plThreeButtonModalOnButton3Click)
        if (e.data.callback) e.data.callback();
    },
    plThreeButtonModalOnButton2Click: function (e) {
        puritanLawn.plThreeButtonModalDetachButtonClickHandlers(puritanLawn.plThreeButtonModalOnButton1Click, puritanLawn.plThreeButtonModalOnButton2Click, puritanLawn.plThreeButtonModalOnButton3Click)
        if (e.data.callback) e.data.callback();
    },
    plThreeButtonModalOnButton3Click: function (e) {
        puritanLawn.plThreeButtonModalDetachButtonClickHandlers(puritanLawn.plThreeButtonModalOnButton1Click, puritanLawn.plThreeButtonModalOnButton2Click, puritanLawn.plThreeButtonModalOnButton3Click)
        if (e.data.callback) e.data.callback();
    },
    plThreeButtonModalAttachButtonClickHandlers: function (onButton1Click, onButton1ClickData, onButton2Click, onButton2ClickData, onButton3Click, onButton3ClickData) {
        $("#pl-threeButtonModalButton1").on("click", { callback: onButton1ClickData }, onButton1Click);
        $("#pl-threeButtonModalButton2").on("click", { callback: onButton2ClickData }, onButton2Click);
        $("#pl-threeButtonModalButton3").on("click", { callback: onButton3ClickData }, onButton3Click);
    },
    plThreeButtonModalDetachButtonClickHandlers: function (onButton1Click, onButton2Click, onButton3Click) {
        $("#pl-threeButtonModalButton1").off("click", onButton1Click);
        $("#pl-threeButtonModalButton2").off("click", onButton2Click);
        $("#pl-threeButtonModalButton3").off("click", onButton3Click);
    },
    showThreeButtonModal: function (title, content, button1, onButton1, button2, onButton2, button3, onButton3) {
        $("#pl-threeButtonModalTitle").html(title);
        $("#pl-threeButtonModalContent").html(content);
        $("#pl-threeButtonModalButton1").text(button1);
        $("#pl-threeButtonModalButton2").text(button2);
        $("#pl-threeButtonModalButton3").text(button3);
        puritanLawn.plThreeButtonModalAttachButtonClickHandlers(puritanLawn.plThreeButtonModalOnButton1Click,
            onButton1,
            puritanLawn.plThreeButtonModalOnButton2Click,
            onButton2,
            puritanLawn.plThreeButtonModalOnButton3Click,
            onButton3);
        $('#pl-threeButtonModal').modal();
    },

    // Image modal
    showImageModal: function (url) {
        $("#pl-imageModalImage").attr("src", url);
        $('#pl-imageModal').modal();
    },

    // Video modal
    showVideoModal: function (url) {
        $("#pl-videoModalVideo").attr("src", url);
        $('#pl-videoModal').modal();
    },

    showSubmitConfirmationModal: function (title, content, onCancel, onSubmit) {
        $("#pl-twoButtonModalTitle").html(title);
        $("#pl-twoButtonModalContent").html(content);
        $("#pl-twoButtonModalButton1").text("Cancel");
        $("#pl-twoButtonModalButton2").text("Submit");
        puritanLawn.plTwoButtonModalAttachButtonClickHandlers(puritanLawn.plSubmitConfirmationModalCancelButtonClickHandler,
            onCancel,
            puritanLawn.plSubmitConfirmationModalSubmitButtonClickHandler,
            onSubmit);
        $('#pl-twoButtonModal').modal();
    },
    showPreviewModal: function (title, url) {
        $("#pl-searchModalTitle").html(title);
        puritanLawn.search.onSelectCallback = onSelectCallback;
        $('#pl-searchModal').modal();
    },
    reload: function (interval) {
        setInterval(function () {
            location.reload();
        }, interval);
    },

    // Text size (root %): step 0 = default only; steps 1–5 = five increases. Sync with _FontSizeHeadBootstrap.cshtml.
    fontSizeStorageKey: 'plFontStep',
    fontSizeMinStep: 0,
    fontSizeMaxStep: 5,
    fontSizeStepPct: 10,
    fontSizePersistToServer: false,

    getFontSizeStep: function () {
        try {
            var n = parseInt(localStorage.getItem(puritanLawn.fontSizeStorageKey), 10);
            if (isNaN(n)) return 0;
            return Math.max(puritanLawn.fontSizeMinStep, Math.min(puritanLawn.fontSizeMaxStep, n));
        } catch (e) {
            return 0;
        }
    },

    setFontSizeStep: function (step) {
        step = Math.max(puritanLawn.fontSizeMinStep, Math.min(puritanLawn.fontSizeMaxStep, step));
        try {
            localStorage.setItem(puritanLawn.fontSizeStorageKey, String(step));
        } catch (e) { }

        if (puritanLawn.fontSizePersistToServer) {
            var token = $('input[name="__RequestVerificationToken"]').val();
            if (token) {
                $.post('/account/preferences/font-size-step', { step: step, __RequestVerificationToken: token });
            }
        }

        if (step === 0) {
            document.documentElement.style.fontSize = '';
            return;
        }

        document.documentElement.style.fontSize = (100 + step * puritanLawn.fontSizeStepPct) + '%';
    },

    initFontSizeControls: function () {
        $('.js-pl-font-smaller').on('click', function () {
            puritanLawn.setFontSizeStep(puritanLawn.getFontSizeStep() - 1);
        });
        $('.js-pl-font-reset').on('click', function () {
            puritanLawn.setFontSizeStep(0);
        });
        $('.js-pl-font-larger').on('click', function () {
            puritanLawn.setFontSizeStep(puritanLawn.getFontSizeStep() + 1);
        });
    }
}

// Document ready function to hook up generic form behaviors
$(function() {
    if (typeof model != "undefined") {
        puritanLawn.model = model;

        if (typeof initViewModel != "undefined") {
            puritanLawn.viewModel = initViewModel(puritanLawn.model);
        }
    }

    $("#pl-form-cancelButton").click(function (e) {
        puritanLawn.viewModel.onCancel();
    });

    $("#pl-form-submitButton").click(function (e) {
        puritanLawn.viewModel.onSubmit();
    });

    puritanLawn.initFontSizeControls();

    if (typeof window.puritanLawnFontSize !== 'undefined' && window.puritanLawnFontSize.persistToServer === true) {
        puritanLawn.fontSizePersistToServer = true;
    }
});